import ExcelJS from "exceljs";

export const downloadExcel = async (
  headers: { header: string; key: string; width?: number }[],
  data: any[],
  title: string,
) => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("회원 설문 조사");

    // 헤더 설정
    worksheet.columns = headers;

    // 헤더 스타일 설정
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE6E6FA" },
    };
    worksheet.getRow(1).alignment = {
      vertical: "middle",
      horizontal: "center",
    };

    // 데이터 추가
    data.forEach((item) => {
      worksheet.addRow(item);
    });

    // 모든 셀 정렬
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell((cell) => {
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      }
    });

    // 엑셀 파일 생성 및 다운로드
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    link.download = `${title}.xlsx`;
    link.click();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("엑셀 다운로드 실패:", error);
    alert("엑셀 다운로드에 실패했습니다.");
  }
};
